import { render, staticRenderFns } from "./NavigationPortal.vue?vue&type=template&id=7dd11a1d&scoped=true"
import script from "./NavigationPortal.vue?vue&type=script&lang=js"
export * from "./NavigationPortal.vue?vue&type=script&lang=js"
import style0 from "./NavigationPortal.vue?vue&type=style&index=0&id=7dd11a1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd11a1d",
  null
  
)

export default component.exports